import { shoplazzaAddCart } from '@/utils/addCart/platforms/shoplazza';

export const initPlatformAddCart = (load: Function) => {
  shoplazzaAddCart(load);
};
